export var REJECTED = '@flight/apiRequest/REJECTED';
export var UNEXPECTED_ERROR = '@flight/apiRequest/UNEXPECTED_ERROR';